import { AppState } from '../../init/rootReducer';
import { PasswordResetPageState } from './reducer';

const getPasswordResetPageState = (state: AppState): PasswordResetPageState =>
  state.containers.passwordReset;

export default getPasswordResetPageState;
